// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"4520": "ca7d58f4","5448": "7c713db2","8167": "bb7404bd",}[chunkId] + ".css"
}